<template>
  <div id="weixiao">
    <div v-if="width >= 992" class="pc">
      <div id="style"></div>
      <HomeHeater></HomeHeater>
      <ContactItem />
      <router-view />
      <div id="bodyBox">
        <!-- <HomeBottom
          :navList="navList"
          :HomeBottomPopList="HomeBottomPopList"
          v-if="name != 'securityCheck'"
        > -->
        <div class="bodyBox-bottom">
          <ContactUs v-if="this.$route.name != 'aboutUs'"></ContactUs>

          <HomeFooter />
        </div>
      </div>
    </div>
    <div v-else class="mobilePage">
      <TopMenu />
      <router-view />
      <div class="bottomBox">
        <HomeFooter />
      </div>
    </div>
  </div>
  <!-- <div v-else></div> -->
</template>

<script>
import HomeHeater from "./HomeHeater";
import HomeFooter from "./HomeFooter";
import ContactItem from "./ContactItem";
import ContactUs from "./ContactUs";

export default {
  name: "weixiao",
  components: {
    HomeHeater,
    HomeFooter,
    ContactItem,
    ContactUs
  },
  data() {
    return {
      width: 1920,
      showEn: true,
      scroll: "",
      name: "",
      navList: [],
      HomeBottomPopList: []
    };
  },
  created() {
    // console.log("-----------", this);
    this.width = outerWidth;
    window.addEventListener("resize", () => {
      this.width = outerWidth;
    });
    this.name = this.$route.name;
    // this.testChina();
    // this.getNavList();
    // this.getHomeBottomPop();
  },
  watch: {
    "$route.name"(val) {
      this.path = val;
      document.documentElement.scrollTop = 0;
    }
  },
  methods: {}
};
</script>
<style scoped>
.weixiao {
  width: 100vw;
}
.bodyBox-bottom {
  /* width: 100%;
  position: fixed;
  bottom: 0; */
}
@media screen and (max-width: 992px) {
  h1,
  h2 {
    font-weight: normal;
    font-size: 12px;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }
}
</style>
<style>
@media screen and (max-width: 992px) {
  * {
    box-sizing: border-box;
  }

  .queryBtnBox {
    position: fixed;
    right: 27px;
    bottom: 120px;
    z-index: 999;
    height: 170px;
  }

  .bottomBox {
    position: relative;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
  }
}

* {
  padding: 0;
  margin: 0;
}

.banner > img {
  width: 100%;
}
.mobilePage {
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue